import React from 'react';
import CensusSection from '../Common/CensusSection';
import ThemeMap from '../Theme/ThemeMap';

const Pct = () => (
    <CensusSection
        menuPath="pct"
        pages={[
            { path: 'indigenous-people', title: 'Pessoas indígenas', element: <ThemeMap theme="pessoas_indigenas" /> },
            {
                path: 'indigenous-households',
                title: 'Domicílios indígenas',
                element: <ThemeMap theme="domicilios_indigenas" />
            },
            {
                path: 'quilombola-people',
                title: 'Pessoas quilombolas',
                element: <ThemeMap theme="pessoas_quilombolas" />
            },
            {
                path: 'quilombola-households',
                title: 'Domicílios quilombolas',
                element: <ThemeMap theme="domicilios_quilombolas" />
            }
        ]}
    />
);

export default Pct;
